import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** Chats pinned in the sidebar (ADMIN-208), as tiles that reopen them. */
export default defineWidget({
  type: "kourai.pinned",
  version: 1,
  title: "Pinned chats",
  description: "Chats you pinned, one click away",
  sizes: ["m", "l", "w"],
  defaultSize: "m",
  surfaces: ["newtab", "sidepanel"],
  data: "none",
  permissions: [],
  max: 1,
  config: z.object({}),
  load: () => import("./pinned-widget"),
});
